// Bookie · Anor (bookie-wine) — variant that renders the standalone
// HTML template (intimate fotixa / engagement invitation, wine accent
// on ivory paper with a single gold ring glint, interlinked-rings
// motif on HERO and a smaller echo above DETAILS, Cormorant Garamond
// italic display + Marcellus body + Pinyon Script accent, theater-
// curtain framing on desktop) inside a full-bleed iframe. The HTML
// lives at /templates/bookie-wine.html and reads the names/date/
// venue/address/time payload from the iframe URL — the customizer
// swaps mocks before first paint. Silent occasion: no music script.
//
// We pass payload values via the URL because postMessage would race
// the iframe's first paint and the customizer needs to run before
// the IntersectionObserver inside the HTML attaches.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-wine.html";

export function BookieWineStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) {
    // Convert dd.mm.yyyy → ISO yyyy-mm-dd for the customizer.
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces leave ctx.slug undefined.
  if (ctx.slug) params.set("slug", ctx.slug);
  // Cache buster — bump when the static HTML changes.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Maftuna & Komron"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#FAF3E3",
      }}
    />
  );
}
